import { render, staticRenderFns } from "./CarreraEdit.vue?vue&type=template&id=3d8a2e1f&"
import script from "./CarreraEdit.vue?vue&type=script&lang=js&"
export * from "./CarreraEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports